import { initState as example } from './example/initState';

export const setInitStates = {
	//
	example,
};
